import './scss/main.scss'

/* ===========================================================================
 Font-Awesome
 =========================================================================== */

import {library, dom} from '@fortawesome/fontawesome-svg-core'
import {faXmark, faShareNodes, faEnvelope, faPhone, faUser, faUniversalAccess,  faSignOutAlt, faRightLong, faBars, faMicrophoneLines} from '@fortawesome/free-solid-svg-icons'
//import {far} from '@fortawesome/free-regular-svg-icons'
import {
    faFacebookF,
    faSoundcloud,
    faTwitter,
    faTwitch,
    faYoutube,
    faFacebookSquare,
    faLinkedin,
    faInstagram
} from '@fortawesome/free-brands-svg-icons'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-thin-svg-icons'


library.add(
    faXmark,
    faUser,
    faUniversalAccess,
    faSignOutAlt,
    faRightLong,
    faFacebookF, faFacebookSquare,
    faSoundcloud,
    faTwitter,
    faLinkedin,
    faTwitch,
    faBars,
    faChevronLeft,
    faChevronRight,
    faMicrophoneLines,
    faYoutube,
    faShareNodes,
    faEnvelope,
    faPhone,
    faInstagram
);

dom.i2svg();

dom.watch();

/* ===========================================================================
 Application JS
 =========================================================================== */
import "@markusantonwolf/ta-youtube/src/scripts/ta-youtube.js";
import 'lazysizes';
import 'sharer.js'
import "./js/app";

/* ===========================================================================
 Init AlpineJS
 =========================================================================== */
import "@kingshott/iodine";

import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
window.Alpine = Alpine;
Alpine.plugin(persist);

Alpine.start();





